// extracted by mini-css-extract-plugin
module.exports = {"content":"_02712f2b3b--content--V1OKe","icon":"_02712f2b3b--icon--JVDwZ","heading":"_02712f2b3b--heading--ks9G6","footer":"_02712f2b3b--footer--q7sTy"};